export default {
  EN_US: 'en-US',
  // This is for indian english. Date and currency will follow this Locale.
  EN_IN: 'en-IN',
  HI_IN: 'hi-IN',
};
